import React from 'react';
import { NumericFormat } from 'react-number-format';

interface NumberFormatterProps {
  amount: string | number;
}

const NumberFormatter: React.FC<NumberFormatterProps> = ({ amount }) => {
  return (
    <NumericFormat
      value={amount}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      fixedDecimalScale
      className="amount-value"
      displayType="text"
    />
  );
};

export default NumberFormatter;
